import PropTypes from "prop-types";

import TabBodyContainer from "./TabBodyContainer";

export default function TabBody({ tabList, tabValue }) {
  return (
    <div className="h-full bg-white py-0 shadow-lg">
      {tabList.map((tab, index) => (
        <TabBodyContainer
          key={"tabpanel_" + index}
          value={tabValue}
          index={index}
          className="h-full"
        >
          {tab.component}
        </TabBodyContainer>
      ))}
    </div>
  );
}

TabBody.propTypes = {
  tabList: PropTypes.array,
  tabValue: PropTypes.number,
};
